import React from 'react'
import { Link } from 'react-static'

import SectionTitle from 'components/Section-Title'
import ColorBar from 'components/Color-Bar'

import contentImageUrl from '../static/img/content-development.jpg'

class Development extends React.Component {
  render() {
    return (
      <React.Fragment>
        <ColorBar />

        <div className="container container--layer-up">
          <div className="layout layout--img-right layout--grey">
            <div className="layout__item">
              <SectionTitle
                align="left"
                icon="icon-development.svg"
                title="Development"
                titleMarginLarge
              />
              <p>As a property development company we work on projects from inception to completion. Through direct investment or with a joint venture partner we will run the planning, construction management with end occupiers in mind. More often than not, in this economic climate, the project is prelet or presold thereby de-risking the project and enhancing returns</p>
            </div>
            <div className="layout__item parallax aspect-ratio--min-twelve-ten" style={{ backgroundImage: `url(${contentImageUrl})`, backgroundSize: 'cover' }} />
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default Development;



// WEBPACK FOOTER //
// /Users/terrymasher/Development/glenbeigh-ltd/src/components/Development.js